/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type SendNormalChatMessagesInput = {
  chatRoomIds: Array<string | number>;
  message: string;
  sendAsStaff?: boolean | null | undefined;
};

export type SendQuestionChatMessagesInput = {
  answerSelections: Array<string>;
  chatRoomIds: Array<string | number>;
  message: string;
  sendAsStaff?: boolean | null | undefined;
};

export type SendNormalChatMessagesMutationVariables = Exact<{
  input: Types.SendNormalChatMessagesInput;
}>;


export type SendNormalChatMessagesMutation = { sendNormalChatMessages: { isSucceeded: boolean } };

export type SendQuestionChatMessagesMutationVariables = Exact<{
  input: Types.SendQuestionChatMessagesInput;
}>;


export type SendQuestionChatMessagesMutation = { sendQuestionChatMessages: { isSucceeded: boolean } };


export const SendNormalChatMessagesDocument = gql`
    mutation sendNormalChatMessages($input: SendNormalChatMessagesInput!) {
  sendNormalChatMessages(input: $input) {
    isSucceeded
  }
}
    `;

/**
 * __useSendNormalChatMessagesMutation__
 *
 * To run a mutation, you first call `useSendNormalChatMessagesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendNormalChatMessagesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendNormalChatMessagesMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSendNormalChatMessagesMutation(options: VueApolloComposable.UseMutationOptions<SendNormalChatMessagesMutation, SendNormalChatMessagesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendNormalChatMessagesMutation, SendNormalChatMessagesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SendNormalChatMessagesMutation, SendNormalChatMessagesMutationVariables>(SendNormalChatMessagesDocument, options);
}
export type SendNormalChatMessagesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendNormalChatMessagesMutation, SendNormalChatMessagesMutationVariables>;
export const SendQuestionChatMessagesDocument = gql`
    mutation sendQuestionChatMessages($input: SendQuestionChatMessagesInput!) {
  sendQuestionChatMessages(input: $input) {
    isSucceeded
  }
}
    `;

/**
 * __useSendQuestionChatMessagesMutation__
 *
 * To run a mutation, you first call `useSendQuestionChatMessagesMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSendQuestionChatMessagesMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSendQuestionChatMessagesMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSendQuestionChatMessagesMutation(options: VueApolloComposable.UseMutationOptions<SendQuestionChatMessagesMutation, SendQuestionChatMessagesMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SendQuestionChatMessagesMutation, SendQuestionChatMessagesMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SendQuestionChatMessagesMutation, SendQuestionChatMessagesMutationVariables>(SendQuestionChatMessagesDocument, options);
}
export type SendQuestionChatMessagesMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SendQuestionChatMessagesMutation, SendQuestionChatMessagesMutationVariables>;